<template>
  <section
    class="component-bb9016f3"
    resmed-component-name="callout_30/70_icon-line_info_text_link_carousel"
  >
    <div
      class="component -transition-in-view"
      v-bind:class="{ 'has-background': acf.layout['background'] }"
      v-bind:style="{
        background: acf.layout['background'],
      }"
    >
      <div class="container">
        <div
          class="row align-items-center"
          v-bind:class="[
            `-placement-${acf['box-a']['placement'].toLowerCase()}`,
          ]"
        >
          <div
            class="col-xl-5 px-xl-0 -in-view-slide-fade-lr"
            style="z-index: 1"
          >
            <div
              class="box-a"
              v-bind:class="[
                `-background-color-${acf['box-a'][
                  'background-color'
                ].toLowerCase()}`,
              ]"
              v-bind:style="style"
            >
              <div ref="swiperContainer" class="swiper-container">
                <div class="items swiper-wrapper">
                  <div
                    class="item swiper-slide"
                    v-for="item in acf['box-a'].items"
                  >
                    <div class="wrapper">
                      <h5>{{ item.question }}</h5>
                      <h2 v-html="item.answer"></h2>
                    </div>
                  </div>
                </div>
              </div>
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
          <div class="col-xl-7 px-xl-0 -in-view-slide-fade-lr">
            <div class="box-b">
              <div class="wrapper">
                <eyebrow-icon
                  v-if="acf['box-b'].eyebrowicon"
                  v-bind:eyebrowicon="acf['box-b'].eyebrowicon"
                ></eyebrow-icon>
                <div class="item" v-for="item in acf['box-b'].items">
                  <h4>{{ item.question }}</h4>
                  <div v-html="item.answer"></div>
                </div>
                <div class="call-to-action mt-3" v-if="acf.cta.href">
                  <a
                    v-bind:href="acf.cta.href"
                    v-bind:target="acf.cta.target"
                    class="btn cta-plain text-red icon right-arrow"
                    >{{ acf.cta.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import inview from "../../mixins/inview";
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-bb9016f3", // callout_30/70_icon-line_info_text_link_carousel
  props: ["acf"],
  data() {
    return {
      style: {},
      initialized: false,
      slider: undefined,
    };
  },
  mixins: [helper, inview],
  watch: {
    inview(val) {
      this.slider.autoplay.start();
    },
  },
  methods: {
    swhCreate() {
      let count = 0;

      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        autoplay: {
          delay: 5000,
        },
        on: {
          reachEnd() {
            if (count === 3) {
              this.autoplay.stop();
            }
          },
        },
      });

      this.slider.autoplay.stop();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.swhReload();
      this.initialized = true;
    });
  },
  created() {
    let hex = this.acf["box-a"]["hex-color"];

    if (hex && this.acf["box-a"]["background-color"] === "Other") {
      this.style["background-color"] = hex;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-bb9016f3 {
  // -->
}

.component {
  @media (min-width: 1200px) {
    [class*="-placement"] {
      padding: 0 10px;
    }

    .-placement-right {
      > :first-child {
        order: 1;
      }
    }
  }

  h2 {
    font-size: 1.875rem; // typography exception
    line-height: 1.4;
    margin-bottom: 0;

    @media (min-width: 1200px) {
      font-size: 2rem; // typography exception
      line-height: 1.3;
    }
  }

  h4 {
    // position: relative;
    // margin-bottom: .25rem;
    // @extend %eyebrow-left;

    @media (min-width: 768px) {
      margin-bottom: 0.75rem;
    }
  }

  h5 {
    margin-bottom: 1.125rem;
  }

  .swiper-container {
    position: relative;
    overflow: hidden;

    .items {
      display: flex;
    }

    .item {
      display: flex;
      flex-shrink: 0;
      align-items: stretch;
    }
  }

  .swiper-pagination {
    justify-content: flex-start;
    padding: 0;
    margin: 1.5rem 0 0 0;
  }

  > .container {
    margin-bottom: -4rem;
    transform: translateY(-50px);

    @media (min-width: 768px) {
      transform: translateY(-50px);
    }

    @media (min-width: 1200px) {
      transform: translateY(-122px);
    }
  }

  &.has-background {
    > .container {
      margin-bottom: 0;

      @media (min-width: 1200px) {
        margin-bottom: -60px;
      }
    }
  }

  [class*="box-"] {
    border-radius: 8px;
    box-shadow: 0 0 3rem 0 rgba(0, 0, 0, 0.15);

    &.-background-color-purple {
      background-color: $cc-resmed-sa-purple;
    }

    &.-background-color-blue {
      background-color: $cc-resmed-hero-blue;
    }

    &.-background-color-red {
      background-color: $cc-resmed-action-red;
    }
  }

  .box-a {
    padding: 3rem;

    @media (min-width: 768px) {
      padding: 3rem 4rem;
    }

    @media (min-width: 768px) {
      padding: 3rem 4rem;
    }

    @media (min-width: 1200px) {
      padding: 4.5rem 4rem 5rem 5rem;
    }

    @media (max-width: 1199px) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    * {
      color: $cc-resmed-white;
    }
  }

  .box-b {
    padding: 4rem 3rem;
    background-color: $cc-resmed-white;

    @media (min-width: 768px) {
      padding: 3.5rem;
    }

    @media (max-width: 1200px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    .item {
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  // left
  .-placement-left {
    .box-b {
      @media (min-width: 1200px) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  // right
  .-placement-right {
    .box-b {
      @media (min-width: 1200px) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}
</style>